import { z } from "zod";

import { quadrantSchema } from "./roles.ts";

const datumSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/**
 * Body für POST /api/v1/visits. Termine sind segment-spezifisch (FK §3.13 Teil B / TK §4.7).
 *
 * Genau eins von beiden: `scheduledAt` (fester Termin) oder `clarifyUntil`
 * („in Klärung“ bis zu dieser Frist, #351). Geprüft im Service statt per
 * `refine`, weil das MCP-Werkzeug das Schema als Objekt braucht.
 */
export const createVisitSchema = z.object({
  customerId: z.string().uuid(),
  segmentId: z.string().uuid(),
  scheduledAt: datumSchema.optional(),
  clarifyUntil: datumSchema.optional(),
  attendeeIds: z.array(z.string().uuid()).optional(),
  linkedCampaignIds: z.array(z.string().uuid()).optional(),
  shortMinutes: z.string().optional(),
});

/**
 * Body für PATCH /api/v1/visits/:id. `status: "planned"` mit `scheduledAt`
 * macht aus einem Termin „in Klärung“ einen festen (#351); `clarifyUntil`
 * verschiebt die Frist eines Termins in Klärung.
 */
export const updateVisitSchema = z.object({
  scheduledAt: datumSchema.optional(),
  status: z.enum(["planned", "done", "cancelled"]).optional(),
  clarifyUntil: datumSchema.optional(),
  shortMinutes: z.string().optional(),
  attendeeIds: z.array(z.string().uuid()).optional(),
});

/** Body für POST /api/v1/visits/:id/postpone. */
export const postponeVisitSchema = z.object({
  newScheduledAt: datumSchema,
});

/** Body für PUT /api/v1/settings/onsite-frequencies (`segmentId` null = globale Vorgabe). */
export const updateOnsiteFrequencySchema = z.object({
  segmentId: z.string().uuid().nullable().default(null),
  quadrant: quadrantSchema,
  months: z.number().int().positive().nullable(),
});
